var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"layout-page-header"},[_c('PageHeader',{attrs:{"title":"客服中心","hidden-breadcrumb":""}})],1),_c('Card',{staticClass:"ivu-mt",attrs:{"bordered":false,"dis-hover":""}},[_c('o-customer-service')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }